import { Injectable } from '@angular/core';
import { environment } from "./../../../../../environments/environment";
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class RestricoesLgpdService {
  public baseUrlservice: string

constructor(private httpClient: HttpClient) { 
  this.baseUrlservice = environment.URL_API;
}

httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    Authorization: JSON.parse(sessionStorage.getItem('currentUser')).token
  })
};

public buscarServico(url: string, page?: number, size?: number, data_inicial?: string, data_fim?: string, dealer?: string, cpf?: string, restricao?: boolean) {
  let queryParams = new HttpParams();
  
  if (page !== undefined) {
    queryParams = queryParams.set('page', page.toString());
  }
  if (size !== undefined) {
    queryParams = queryParams.set('size', size.toString());
  }
  if (data_inicial !== undefined) {
    queryParams = queryParams.set('data_inicial', data_inicial.toString());
  }
  if (data_fim !== undefined) {
    queryParams = queryParams.set('data_fim', data_fim.toString());
  }
  if (dealer !== undefined) {
    queryParams = queryParams.set('dealer', dealer.toString());
  }
  if (cpf !== undefined) {
    queryParams = queryParams.set('cpf', cpf.toString());
  }
  if (restricao !== undefined) {
    queryParams = queryParams.set('restricao', restricao.toString());
  }

  return this.httpClient.get<any>(`${this.baseUrlservice}${url}`, { params: queryParams, ...this.httpOptions });
}

public buscaSemFiltro(url: string, page?: number, size?: number, data_inicial?: string, data_fim?: string, restricao?: boolean) {
  let queryParams = new HttpParams();
  
  if (page !== undefined) {
    queryParams = queryParams.set('page', page.toString());
  }
  if (size !== undefined) {
    queryParams = queryParams.set('size', size.toString());
  }
  if (data_inicial !== undefined) {
    queryParams = queryParams.set('data_inicial', data_inicial.toString());
  }
  if (data_fim !== undefined) {
    queryParams = queryParams.set('data_fim', data_fim.toString());
  }
  if (restricao !== undefined) {
    queryParams = queryParams.set('restricao', restricao.toString());
  }

  return this.httpClient.get<any>(`${this.baseUrlservice}${url}`, { params: queryParams, ...this.httpOptions });
}

}
